import { render, staticRenderFns } from "./shareClueDialog.vue?vue&type=template&id=5bb513e6&scoped=true"
import script from "./shareClueDialog.vue?vue&type=script&lang=js"
export * from "./shareClueDialog.vue?vue&type=script&lang=js"
import style0 from "./shareClueDialog.vue?vue&type=style&index=0&id=5bb513e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb513e6",
  null
  
)

export default component.exports